import React from 'react'
import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'

export interface Props {
  text?: string
  className?: string
  color?: string
  paddings?: string
  bg?: string
}

export const TwContainer = tw.div`
  h-16
  flex
  rounded-4
  items-center
  text-xxxs-semibold
  w-fit
`

export const LabelBackgrounded = (props: Props) => {
  const {
    text,
    className,
    color = 'text-secondary',
    paddings = 'px-4',
    bg = 'bg-background-subtask-open'
  } = props

  if (!text) {
    return null
  }

  return (
    <TwContainer className={cn(color, paddings, bg, className)}>
      {text}
    </TwContainer>
  )
}
